import React from "react"

const SpacerBlock = ({
  key,
  spacerHeight=0
}) => {
  return (
    <div className="module-spacer-height" style={{marginTop: `${spacerHeight}px`}}>&nbsp;</div>
  )
}

export default SpacerBlock
